@import "styles/variables";

.carType-container {
  margin: 20px 0 0;
}

.carType-info {
  font-size: 11px;
  color: #cc0000;
  min-height: 2em;
  width: 370px;
}

.radiobuttons {
  display: flex;
  flex-direction: row;
  list-style: none;
  margin: 8px 0 15px;
}

.radio-button {
  flex: 1;
  cursor: pointer;
}

.indicator {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 70px;
  height: 70px;
  padding: 0 20px;
  border: 1px solid var(--color-grey);
  border-right: none;
  transition: box-shadow 0.1s ease-out, transform 0.1s ease-out;
}


.radio-button:first-child .indicator {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

.radio-button:last-child .indicator {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-right: 1px solid var(--color-grey);
}

.radio-button.active .indicator {
  background: var(--color-yellow);
  border-color: var(--color-yellow);        
}

.radio-button.active + .radio-button .indicator {
  border-left-color: transparent;
}

.radio-button input {
  opacity: 0;
  position: absolute;
  z-index: -1;
}

.radio-button img {
  width: 40px;
  /*margin-bottom: 5px;*/
}

.radio-button input:focus ~ .indicator {
  border-color: var(--color-border-orange-focus);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15), inset -1px 0 0 var(--color-border-orange-focus), inset 0 -2px 0 var(--color-border-orange-focus);
  transform: translateY(-1px);
}

.radio-button:last-child input:focus ~ .indicator {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15), inset 0 -2px 0 var(--color-border-orange-focus);
}

.labels {
  display: flex;
  flex-direction: column;  
  text-align: center;
}

.labels.estimate {
  display: block;
  font-size: 0;
}

.label {
  font-size: 16px;
  font-family: var(--font-stack-bold);
  font-size: var(--font-size-medium);  
  color: var(--color-black-transparent);
  vertical-align: baseline;
}

.labelSmall {
  font-family: var(--font-stack-default);
  font-size: var(--font-size-extra-small);
  color: var(--color-black-transparent);
  vertical-align: baseline;
}

.labels.estimate .label {
  margin-right: 4px;  
}

.labels.estimate .label:first-child {
  font-size: 12px;
}

.labels.estimate .labelSmall {
  font-size: 10px;
}

.labels.estimate .labelSmall:after {
  content: '\A';
  white-space: pre;
}

.labels.estimate strong {
  line-height: 14px;
}

.disabled {
  opacity: .3;
  pointer-events: none;
}
